/* =============================================================================
   Bonne Manière · refonte 2026 (thème test)
   Comptes à rebours, fiche produit (variantes, panier, galerie, barre collante),
   collection (tri, tiroir de filtres, « voir plus »), code promo, Klaviyo.
   Aucune dépendance. Le tiroir panier du thème est ouvert via l'événement « ajaxProduct:added ».
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.add('bm-js');

  /* ----------------------------------------------------------- Utilitaires */
  var moneyFormat = (window.theme && theme.settings && theme.settings.moneyFormat) || '{{amount_with_comma_separator}}€';

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var fmt = moneyFormat;
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_with_comma_separator';
    function group(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    var val;
    switch (key) {
      case 'amount': val = group(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': val = group(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': val = group(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = group(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': val = group(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': val = group(cents, 2, "'", '.'); break;
      default: val = group(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function parseParis(s) {
    if (!s) return null;
    s = String(s).trim();
    if (/[zZ]$|[+-]\d\d:?\d\d$/.test(s)) return new Date(s);
    var m = s.match(/(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (!m) return null;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, m[6] ? +m[6] : 0);
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var p = {};
      f.formatToParts(new Date(utc)).forEach(function (x) { p[x.type] = x.value; });
      var asParis = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
      return new Date(utc - (asParis - utc));
    } catch (e) {
      return new Date(utc - 2 * 3600 * 1000);
    }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ------------------------------------------------------ Comptes à rebours */
  function initCountdowns(root) {
    var els = (root || document).querySelectorAll('[data-bm-countdown]:not([data-bm-ready])');
    if (!els.length) return;
    var items = [];
    els.forEach(function (el) {
      el.setAttribute('data-bm-ready', '');
      var end = parseParis(el.getAttribute('data-bm-countdown'));
      if (end && !isNaN(end)) items.push({ el: el, end: end });
    });
    function tick() {
      var now = Date.now();
      items.forEach(function (it) {
        var diff = Math.max(0, Math.floor((it.end - now) / 1000));
        var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
        if (diff === 0) { expire(it.el); return; }
        if (it.el.getAttribute('data-format') === 'cells') {
          var q = function (k) { return it.el.querySelector('[data-' + k + ']'); };
          if (q('d')) q('d').textContent = pad(d);
          if (q('h')) q('h').textContent = pad(h);
          if (q('m')) q('m').textContent = pad(m);
          if (q('s')) q('s').textContent = pad(s);
        } else {
          var label = it.el.getAttribute('data-label') || '';
          it.el.textContent = (label ? label + ' ' : '') + (d > 0 ? pad(d) + ' j ' : '') + pad(h) + ' h ' + pad(m) + ' min' + (d === 0 ? ' ' + pad(s) + ' s' : '');
        }
      });
    }
    function expire(el) {
      el.classList.add('is-over');
      var bar = el.closest('[data-bm-announce]');
      if (bar) {
        var live = bar.querySelector('[data-bm-announce-live]');
        var fb = bar.querySelector('[data-bm-announce-fallback]');
        if (fb) { if (live) live.hidden = true; fb.hidden = false; } else { el.hidden = true; }
      } else {
        el.hidden = true;
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------ Copier un code */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bm-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-bm-copy');
    var label = btn.querySelector('[data-bm-copy-label]');
    var done = function () { if (label) { label.textContent = 'Copié'; setTimeout(function () { label.textContent = 'Copier'; }, 2000); } };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {} document.body.removeChild(t); done();
    }
  });

  /* ------------------------------------------------------ Klaviyo */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bm-klaviyo]');
    if (!btn) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', btn.getAttribute('data-bm-klaviyo')]);
  });

  /* ------------------------------------------------------ Tiroirs */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bm-lock');
    document.querySelectorAll('[data-bm-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = d.querySelector('button, a, input, select');
    if (f) f.focus();
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bm-lock');
    document.querySelectorAll('[data-bm-drawer-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-bm-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-bm-drawer-open')); return; }
    var c = e.target.closest('[data-bm-drawer-close]');
    if (c) { var d = c.closest('[data-bm-drawer]'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('[data-bm-drawer].is-open');
    if (d) closeDrawer(d);
  });

  /* Filtres : on n'envoie pas les champs vides (URL propres) */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.bm-drawer__panel');
    if (!f) return;
    f.querySelectorAll('input').forEach(function (i) { if ((i.type === 'number' || i.type === 'hidden') && !i.value) i.disabled = true; });
  });

  /* ------------------------------------------------------ Collection */
  function initCollection() {
    document.querySelectorAll('[data-bm-sort]:not([data-bm-ready])').forEach(function (sel) {
      sel.setAttribute('data-bm-ready', '');
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('[data-bm-more]:not([data-bm-ready])').forEach(function (more) {
      more.setAttribute('data-bm-ready', '');
      var btn = more.querySelector('[data-bm-more-btn]');
      var grid = document.querySelector('[data-bm-grid]');
      if (!btn || !grid) return;
      btn.addEventListener('click', function () {
        var next = more.getAttribute('data-next');
        if (!next) return;
        btn.classList.add('is-loading');
        btn.textContent = 'Chargement…';
        fetch(next, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('[data-bm-grid] > .bm-card');
            cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
            var nextMore = doc.querySelector('[data-bm-more]');
            var total = Number(more.getAttribute('data-total')) || 0;
            var shown = grid.querySelectorAll('.bm-card').length;
            var label = more.querySelector('[data-bm-more-label]');
            var bar = more.querySelector('[data-bm-more-bar]');
            if (label) label.textContent = 'Vous avez vu ' + Math.min(shown, total) + ' pièces sur ' + total;
            if (bar && total) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
            if (nextMore && nextMore.getAttribute('data-next')) {
              more.setAttribute('data-next', nextMore.getAttribute('data-next'));
              btn.classList.remove('is-loading');
              btn.textContent = 'Voir plus de pièces';
            } else {
              btn.remove();
            }
            try { history.replaceState(history.state, '', next); } catch (err) {}
          })
          .catch(function () {
            window.location.href = next;
          });
      });
    });
  }

  /* ------------------------------------------------------ Fiche produit */
  var GRADE_TEXT = {
    'jamais utilisé': { meter: 4, text: 'Produit neuf retourné sans avoir été utilisé, vérifié et contrôlé.' },
    'fin de série': { meter: 4, text: 'Produit neuf de série limitée, jamais utilisé.' },
    'parfait': { meter: 3, text: 'Aucun défaut visible, comme neuf à l’œil et au toucher.' },
    'parfait état': { meter: 3, text: 'Aucun défaut visible, comme neuf à l’œil et au toucher.' },
    'léger défaut': { meter: 2, text: 'Léger défaut qui n’empêche pas une utilisation normale, montré en photo sur la fiche.' },
    'leger defaut': { meter: 2, text: 'Léger défaut qui n’empêche pas une utilisation normale, montré en photo sur la fiche.' }
  };

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-bm-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    saveRecent(data.recent);
    var form = root.querySelector('[data-bm-form]');
    var idInput = root.querySelector('[data-bm-variant-id]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-bm-option]'));
    var addBtn = root.querySelector('[data-bm-add]');
    var addLabel = root.querySelector('[data-bm-add-label]');
    var errorEl = root.querySelector('[data-bm-error]');
    var stickyBar = root.querySelector('[data-bm-sticky]');
    var stickyAdd = root.querySelector('[data-bm-sticky-add]');
    var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];

    function selected() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[Number(r.getAttribute('data-bm-option'))] = r.value; });
      return opts;
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }

    function markAvailability(opts) {
      radios.forEach(function (r) {
        var i = Number(r.getAttribute('data-bm-option'));
        var test = opts.slice(); test[i] = r.value;
        var ok = findVariant(test).some(function (v) { return v.available; });
        r.classList.toggle('is-unavailable', !ok);
      });
    }

    function render(v, initial) {
      if (!v) return;
      current = v;
      if (idInput && !initial) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var price = root.querySelector('[data-bm-price]');
      var compare = root.querySelector('[data-bm-compare]');
      var save = root.querySelector('[data-bm-save]');
      var alma = root.querySelector('[data-bm-alma]');
      var almaAmt = root.querySelector('[data-bm-alma-amount]');
      var deal = root.querySelector('[data-bm-deal]');
      if (price) price.textContent = formatMoney(v.price);
      var hasCompare = v.compare && v.compare > v.price;
      if (compare) { compare.hidden = !hasCompare; if (hasCompare) compare.textContent = formatMoney(v.compare) + ' neuf'; }
      if (save) { save.hidden = !hasCompare; if (hasCompare) save.textContent = '−' + formatMoney(v.compare - v.price).replace(/,00(?=\D*$)/, ''); }
      if (deal) { if (hasCompare) { deal.hidden = false; deal.textContent = '−' + Math.floor((v.compare - v.price) * 100 / v.compare) + ' %'; } else { deal.hidden = true; } }
      if (alma) { alma.hidden = v.price < 5000; if (almaAmt) almaAmt.textContent = '4 × ' + formatMoney(Math.floor(v.price / 4)); }

      function niceOpt(o) {
        o = String(o).replace('Leger defaut', 'Léger défaut');
        return /^\d+x\d+cm$/.test(o) ? o.replace('x', ' x ').replace('cm', ' cm') : o;
      }
      root.querySelectorAll('[data-bm-opt-value]').forEach(function (el) {
        var i = Number(el.getAttribute('data-bm-opt-value'));
        if (v.options[i] !== undefined) el.textContent = ': ' + niceOpt(v.options[i]);
      });

      var stock = root.querySelector('[data-bm-stock]');
      if (stock) {
        var msg = '';
        if (!v.available) msg = '';
        else if (v.qty === 1) msg = '<b>Pièce unique :</b> il n’en reste qu’un exemplaire.';
        else if (v.qty > 1 && v.qty <= 3) msg = '<b>Plus que ' + v.qty + ' en stock.</b>';
        stock.innerHTML = msg;
      }

      root.classList.toggle('is-soldout', !v.available);
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      var sp = root.querySelector('[data-bm-sticky-price]');
      var ss = root.querySelector('[data-bm-sticky-sub]');
      if (sp) sp.textContent = formatMoney(v.price);
      if (ss) ss.textContent = v.price >= 5000 ? 'ou 4 × ' + formatMoney(Math.floor(v.price / 4)) : '';

      if (data.gradeIndex > 0) {
        var g = v.options[data.gradeIndex - 1] || '';
        var nameEl = root.querySelector('[data-bm-grade-name]');
        var textEl = root.querySelector('[data-bm-grade-text]');
        var meter = root.querySelectorAll('[data-bm-grade-meter] i');
        var info = GRADE_TEXT[g.toLowerCase()] || { meter: 0, text: '' };
        if (nameEl) nameEl.textContent = g === 'Leger defaut' ? 'Léger défaut' : g;
        if (textEl) textEl.textContent = info.text;
        root.classList.toggle('has-defect', /d[ée]faut/i.test(g));
        meter.forEach(function (m, i) { m.classList.toggle('is-on', i < info.meter); });
      }

      if (typeof applySets === 'function') applySets(v);
      if (initial) { markAvailability(v.options.slice()); return; }
      if (v.media && !hasSets) goToMedia(v.media);

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}

      markAvailability(v.options.slice());
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var opts = selected();
        var exact = findVariant(opts)[0];
        if (exact && exact.available) { render(exact); return; }
        // Combinaison indisponible : on garde la valeur choisie et on prend la meilleure variante disponible
        var i = Number(r.getAttribute('data-bm-option'));
        var alt = variants.filter(function (v) { return v.options[i] === r.value && v.available; })[0] || exact;
        if (alt) {
          radios.forEach(function (x) {
            var j = Number(x.getAttribute('data-bm-option'));
            x.checked = alt.options[j] === x.value;
          });
          render(alt);
        }
      });
    });

    /* Galerie */
    var track = root.querySelector('[data-bm-track]');
    var count = root.querySelector('[data-bm-count]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bm-thumb]'));
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    function isRail() { return track && track.scrollWidth > track.clientWidth + 4; }
    function goToIndex(i) {
      var s = slides[i];
      if (!s) return;
      if (isRail()) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      else if (i > 0) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function goToMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) { goToIndex(i); return; }
      }
    }
    /* Photos par variante : on garde les photos sans marqueur et celles du coloris / grade choisi
       (en tête), on masque les autres. Comparaison sans accents : « Léger défaut » = « leger-defaut ». */
    function slug(x) {
      return String(x || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    var setNames = {};
    (data.optionNames || []).forEach(function (n, i) { setNames[slug(n)] = i; });
    var hasSets = slides.some(function (sl) { return sl.hasAttribute('data-set') && slug(sl.getAttribute('data-set')) in setNames; });
    var visible = slides.slice();
    function applySets(v) {
      if (!hasSets || !v) return;
      var matched = [], plain = [], hidden = [];
      slides.forEach(function (sl) {
        var set = slug(sl.getAttribute('data-set'));
        if (!sl.hasAttribute('data-set') || !(set in setNames)) { plain.push(sl); return; }
        if (slug(sl.getAttribute('data-val')) === slug(v.options[setNames[set]])) matched.push(sl); else hidden.push(sl);
      });
      visible = matched.length || plain.length ? matched.concat(plain) : slides.slice();
      slides.forEach(function (sl, k) {
        var pos = visible.indexOf(sl);
        sl.hidden = pos === -1;
        sl.style.order = pos === -1 ? '' : pos;
        sl.classList.toggle('is-lead', pos === 0);
        if (thumbs[k]) { thumbs[k].hidden = pos === -1; thumbs[k].style.order = pos === -1 ? '' : pos; thumbs[k].classList.toggle('is-active', pos === 0); }
      });
      track.classList.add('is-sets');
      if (count) count.textContent = '1 / ' + visible.length;
      if (track.scrollTo) track.scrollTo({ left: 0 });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToIndex(Number(t.getAttribute('data-bm-thumb'))); });
    });
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (count) count.textContent = (i + 1) + ' / ' + visible.length;
          var cur = visible[i];
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', slides[k] === cur); });
        });
      }, { passive: true });
    }

    /* Zoom plein écran (photos uniquement) */
    var zoomables = slides.filter(function (sl) { return sl.hasAttribute('data-zoom'); });
    function openZoom(startSlide) {
      // Photos visibles pour la variante choisie, dans l'ordre affiché
      var list = visible.filter(function (sl) { return sl.hasAttribute('data-zoom'); });
      var start = Math.max(0, list.indexOf(startSlide));
      var box = document.createElement('div');
      box.className = 'bm bm-zoom';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Photos en plein écran');
      box.innerHTML = '<button type="button" class="bm-zoom__close" aria-label="Fermer">×</button><div class="bm-zoom__track"></div><span class="bm-zoom__count"></span>';
      var tr = box.querySelector('.bm-zoom__track');
      list.forEach(function (sl) {
        var fig = document.createElement('div');
        fig.className = 'bm-zoom__slide';
        var im = document.createElement('img');
        im.src = sl.getAttribute('data-zoom');
        im.alt = (sl.querySelector('img') || {}).alt || '';
        im.loading = 'lazy';
        fig.appendChild(im);
        tr.appendChild(fig);
      });
      document.body.appendChild(box);
      document.documentElement.classList.add('bm-lock');
      var count = box.querySelector('.bm-zoom__count');
      var upd = function () { var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); count.textContent = (i + 1) + ' / ' + list.length; };
      tr.addEventListener('scroll', upd, { passive: true });
      requestAnimationFrame(function () { tr.scrollLeft = start * tr.clientWidth; upd(); });
      var close = function () { box.remove(); document.documentElement.classList.remove('bm-lock'); document.removeEventListener('keydown', onKey); };
      var onKey = function (e) {
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') tr.scrollBy({ left: tr.clientWidth, behavior: 'smooth' });
        if (e.key === 'ArrowLeft') tr.scrollBy({ left: -tr.clientWidth, behavior: 'smooth' });
      };
      document.addEventListener('keydown', onKey);
      box.querySelector('.bm-zoom__close').addEventListener('click', close);
      box.querySelector('.bm-zoom__close').focus();
    }
    zoomables.forEach(function (sl) {
      sl.addEventListener('click', function () { openZoom(sl); });
      sl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(sl); } });
    });

    /* Ajout au panier */
    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }
    function addToCart() {
      if (!current || !current.available) return;
      setError('');
      if (addBtn) addBtn.classList.add('is-loading');
      if (addLabel) addLabel.textContent = 'Ajout…';
      // Attend la fin d'une écriture panier en cours (ex. Gorgias), sinon deux paniers et article perdu
      (window.bmWhenCartIdle || function (f) { f(); })(function () {
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (addBtn) addBtn.classList.remove('is-loading');
          if (!res.ok) {
            if (addLabel) addLabel.textContent = 'Ajouter au panier';
            setError(res.body && (res.body.description || res.body.message) || 'Impossible d’ajouter ce produit au panier.');
            return;
          }
          if (addLabel) { addLabel.textContent = 'Ajouté ✓'; setTimeout(function () { addLabel.textContent = 'Ajouter au panier'; }, 2500); }
          var item = res.body && res.body.items ? res.body.items[0] : res.body;
          var cartType = window.theme && theme.settings && theme.settings.cartType;
          if (cartType && cartType !== 'drawer') { window.location.href = (theme.routes && theme.routes.cartPage) || '/cart'; return; }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item, addToCartBtn: addBtn } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function () {
          if (form) form.submit();
        });
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

    /* Barre collante : visible quand le bouton principal sort de l'écran */
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          var show = !en.isIntersecting && below;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(addBtn);
    }

    /* Explicatif des états (modale du thème) */
    root.querySelectorAll('[data-bm-grade-help]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (typeof window.lhOpenGradeModal === 'function') window.lhOpenGradeModal(e);
        else window.location.href = '/pages/charte-qualite';
      });
    });

    render(current, true);
  }

  /* ------------------------------------------------------ Recommandations (repli) */
  function initReco(root) {
    (root || document).querySelectorAll('[data-bm-reco]:not([data-bm-ready])').forEach(function (el) {
      el.setAttribute('data-bm-ready', '');
      fetch(el.getAttribute('data-bm-reco'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.bm-related');
          if (sec) el.replaceWith(document.importNode(sec, true));
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------ Panier (tiroir et page) */
  function initCart(root) {
    (root || document).querySelectorAll('[data-bm-cart]:not([data-bm-ready])').forEach(function (cart) {
      cart.setAttribute('data-bm-ready', '');
      var ship = cart.querySelector('[data-bm-ship]');
      var codeBox = cart.querySelector('[data-bm-code]');
      function refresh() {
        var items = cart.querySelector('.cart__items');
        if (!items) return;
        var total = Number(items.dataset.cartSubtotal) || 0;
        var saved = Number(items.dataset.bmSavings) || 0;
        var hasMatelas = items.dataset.bmMatelas === 'true';
        var codes = (items.dataset.bmCodes || '').split(',');
        if (ship) {
          var threshold = Number(ship.dataset.threshold) || 15000;
          var rest = threshold - total;
          ship.querySelector('[data-bm-ship-fill]').style.width = Math.min(100, Math.round(total * 100 / threshold)) + '%';
          ship.querySelector('[data-bm-ship-msg]').innerHTML = rest > 0
            ? 'Plus que <b>' + formatMoney(rest) + '</b> pour la livraison offerte'
            : '<b>Livraison offerte</b> sur votre commande';
          ship.classList.toggle('is-done', rest <= 0);
        }
        // Livraison offerte à portée : 3 petites pièces qui suffisent à atteindre le seuil,
        // assorties au panier (famille, dimensions du lit), jamais un produit déjà au panier
        var boost = cart.querySelector('[data-bm-boost]');
        // Réserve chargée à la demande (seulement si le panier est sous le seuil) : rien sur les autres pages
        if (boost && ship && boost.dataset.src && !boost.dataset.loaded) {
          var need0 = (Number(ship.dataset.threshold) || 15000) - total;
          var bx = boost;
          if (need0 > 0 && total > 0 && !bx.dataset.loading) {
            bx.dataset.loading = '1';
            fetch(bx.dataset.src, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
              var tmp = document.createElement('div'); tmp.innerHTML = h;
              var src = tmp.querySelector('[data-bm-boost]');
              if (src) bx.innerHTML = src.innerHTML;
              bx.dataset.loaded = '1';
              refresh();
            }).catch(function () { delete bx.dataset.loading; });
          }
          boost = null;
        }
        if (boost && ship) {
          var need = (Number(ship.dataset.threshold) || 15000) - total;
          var pool = Array.prototype.slice.call(boost.querySelectorAll('[data-variant]'));
          pool.forEach(function (li) { li.hidden = true; });
          boost.hidden = true;
          if (need > 0 && total > 0) {
            fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
              var inCart = {}, sizes = {}, bedding = false, living = false;
              (c.items || []).forEach(function (it) {
                inCart[String(it.product_id)] = true;
                var t = ((it.product_type || '') + ' ' + (it.product_title || '')).toLowerCase();
                if (/matelas|sommier|(^|\s)lits?(\s|$)|t[êe]te de lit|couchage/.test(t)) bedding = true;
                if (/canap|fauteuil|m[ée]ridienne|chaise|table|buffet|meuble|banc/.test(t)) living = true;
                (it.options_with_values || []).forEach(function (o) {
                  var v = String(o.value || '').toLowerCase().replace(/\s|cm/g, '').replace('×', 'x');
                  var m = v.match(/(\d{2,3})x(\d{2,3})/);
                  if (m) sizes[m[1] + 'x' + m[2]] = true;
                });
              });
              var cats = bedding ? ['linge', 'couette'] : (living ? ['tapis', 'deco', 'luminaire'] : null);
              // Tailles de linge compatibles : drap housse = taille du lit ; parure et couette = largeur du lit
              var BY_WIDTH = { '90': ['140x200', '140x190', '200x140'], '140': ['200x200', '220x240', '240x220'], '160': ['220x240', '240x220', '240x260', '260x240'],
                '180': ['240x260', '260x240'], '200': ['260x240', '280x240', '240x280'] };
              var fits = {};
              Object.keys(sizes).forEach(function (bed) {
                fits[bed] = true;
                var w = bed.split('x')[0];
                (BY_WIDTH[w] || []).forEach(function (k) { fits[k] = true; });
              });
              var ok = pool.filter(function (li) {
                if (Number(li.dataset.price) < need || inCart[li.dataset.product]) return false;
                if (cats && cats.indexOf(li.dataset.cat) < 0) return false;
                var sz = (li.dataset.size || '').match(/(\d{2,3})x(\d{2,3})/);
                // Linge et couettes : compatibles avec le lit au panier (sinon on ne les propose pas)
                if ((li.dataset.cat === 'linge' || li.dataset.cat === 'couette') && sz && !fits[sz[1] + 'x' + sz[2]]) return false;
                return true;
              }).sort(function (a, b) {
                var am = a.dataset.size && fits[(a.dataset.size.match(/\d{2,3}x\d{2,3}/) || [''])[0]] ? 0 : 1, bm = b.dataset.size && fits[(b.dataset.size.match(/\d{2,3}x\d{2,3}/) || [''])[0]] ? 0 : 1;
                return am - bm || Number(a.dataset.price) - Number(b.dataset.price);
              });
              var used = {}, pick = [];
              ok.forEach(function (li) { if (pick.length < 3 && !used[li.dataset.product]) { used[li.dataset.product] = true; pick.push(li); } });
              pick.forEach(function (li) { li.hidden = false; });
              boost.hidden = pick.length === 0;
              var sub = boost.querySelector('[data-bm-boost-sub]');
              if (sub) sub.textContent = pick.length > 1 ? 'Une de ces pièces et la livraison vous est offerte.' : 'Ajoutez-la et la livraison vous est offerte.';
            }).catch(function () {});
          }
        }
        var saveRow = cart.querySelector('[data-bm-save]');
        if (saveRow) {
          saveRow.hidden = saved <= 0;
          saveRow.querySelector('[data-bm-save-amount]').textContent = '−' + formatMoney(saved);
        }
        var alma = cart.querySelector('[data-bm-alma]');
        if (alma) {
          alma.hidden = total < 5000;
          alma.querySelector('[data-bm-alma-amount]').textContent = '4 × ' + formatMoney(Math.floor(total / 4));
        }
        if (codeBox) {
          var code = codeBox.dataset.code;
          var applied = codes.indexOf(code) > -1;
          codeBox.hidden = !hasMatelas;
          codeBox.classList.toggle('is-applied', applied);
          codeBox.querySelector('[data-bm-code-text]').textContent = applied ? 'Code ' + code + ' appliqué' : 'avec le code ' + code;
          codeBox.querySelector('[data-bm-code-apply]').hidden = applied;
        }
      }
      cart.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bm-boost-add]');
        if (!btn) return;
        var li = btn.closest('[data-variant]');
        btn.classList.add('is-loading'); btn.disabled = true;
        (window.bmWhenCartIdle || function (f) { f(); })(function () {
          fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(li.dataset.variant), quantity: 1 }] }) })
            .then(function (r) {
              if (!r.ok) throw new Error('stock');
              if (cart.dataset.location === 'page') window.location.reload();
              else document.dispatchEvent(new CustomEvent('cart:build'));
            })
            .catch(function () {
              // Pièce partie entre-temps : on la retire de la liste et on en propose une autre
              var err = cart.querySelector('[data-bm-boost-err]');
              if (err) err.hidden = false;
              li.remove();
              refresh();
            });
        });
      });
      var products = cart.querySelector('[data-products]');
      if (products) new MutationObserver(refresh).observe(products, { childList: true, subtree: false });
      refresh();
      if (codeBox) {
        codeBox.querySelector('[data-bm-code-apply]').addEventListener('click', function (e) {
          var btn = e.currentTarget;
          btn.classList.add('is-loading');
          fetch('/discount/' + encodeURIComponent(codeBox.dataset.code) + '?redirect=/cart.js', { credentials: 'same-origin' })
            .then(function () {
              btn.classList.remove('is-loading');
              if (cart.dataset.location === 'page') window.location.reload();
              else document.dispatchEvent(new CustomEvent('cart:build'));
            })
            .catch(function () { btn.classList.remove('is-loading'); });
        });
      }
    });
  }

  /* ------------------------------------------------------ Trustpilot (différé) */
  function loadTrustpilot() {
    if (window.__bmTp || !document.querySelector('.trustpilot-widget')) return;
    window.__bmTp = true;
    var sc = document.createElement('script');
    sc.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    sc.async = true;
    document.head.appendChild(sc);
  }
  function scheduleTrustpilot() {
    var go = function () { ('requestIdleCallback' in window) ? requestIdleCallback(loadTrustpilot, { timeout: 2500 }) : setTimeout(loadTrustpilot, 1200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach(function (ev) { window.addEventListener(ev, loadTrustpilot, { once: true, passive: true }); });
  }

  /* ------------------------------------------------------ Vus récemment */
  var RECENT_KEY = 'bm_recent_v1';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function saveRecent(item) {
    if (!item || !item.url) return;
    try {
      var list = readRecent().filter(function (x) { return x.url !== item.url; });
      item.t = Date.now();
      list.unshift(item);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function renderRecent(root) {
    (root || document).querySelectorAll('[data-bm-recent]:not([data-bm-ready])').forEach(function (box) {
      box.setAttribute('data-bm-ready', '');
      var exclude = box.getAttribute('data-exclude');
      var list = readRecent().filter(function (x) { return x.url !== exclude && x.available !== false; }).slice(0, 4);
      if (list.length < 2) return;
      var html = '<div class="bm-head-row"><h2 class="bm-h2">' + esc(box.getAttribute('data-title') || 'Vous les avez regardées') + '</h2></div><div class="bm-rail bm-rail--grid">';
      list.forEach(function (x) {
        var save = x.compare > x.price ? Math.floor((x.compare - x.price) * 100 / x.compare) : 0;
        html += '<a class="bm-card" href="' + esc(x.url) + '"><div class="bm-card__media">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="400" height="400">' : '') +
          '<div class="bm-card__badges">' + (save >= 5 ? '<span class="bm-tag bm-tag--deal">−' + save + ' %</span>' : '<span></span>') + '</div></div>' +
          (x.brand ? '<div class="bm-card__brand">' + esc(x.brand) + '</div>' : '') +
          '<div class="bm-card__title">' + esc(x.title) + '</div><div class="bm-card__price"><b>' + formatMoney(x.price) + '</b>' +
          (x.compare > x.price ? '<s>' + formatMoney(x.compare) + ' neuf</s>' : '') + '</div></a>';
      });
      box.innerHTML = html + '</div>';
      box.hidden = false;
    });
  }

  /* ------------------------------------------------------ Typographie française
     Espace insécable avant ? ! : ; » dans les titres, pour ne jamais laisser un « ? » seul en début de ligne. */
  function frenchSpaces(root) {
    (root || document).querySelectorAll('.bm :is(h1, h2, h3, summary, .bm-btn), .article__body :is(p, li, td, th, h2, h3, h4)').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue.replace(/ ([?!:;»€%])/g, ' $1').replace(/« /g, '« ');
        if (t !== n.nodeValue) n.nodeValue = t;
      }
    });
  }

  /* ------------------------------------------------------ Centre d'aide, contact, fiche (chat, statut, recherche) */
  function parisNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { day: parts.weekday, min: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10) };
  }
  // Lun–ven, 9h30–12h et 14h–18h (heure de Paris)
  function phoneOpen() {
    var n = parisNow();
    if (n.day === 'Sat' || n.day === 'Sun') return false;
    return (n.min >= 570 && n.min < 720) || (n.min >= 840 && n.min < 1080);
  }
  function openChat() {
    function open(g) { try { (g.init ? g.init() : Promise.resolve()).then(function () { g.open(); }); } catch (e) { g.open(); } }
    var g = window.GorgiasChat;
    if (g && typeof g.open === 'function') { open(g); return true; }
    // Chat chargé en différé (snippets/bm-lazy-apps) : on le charge et on attend qu'il soit prêt (8 s max)
    if (typeof window.bmLoadApps !== 'function') return false;
    window.bmLoadApps();
    var waited = 0;
    var iv = setInterval(function () {
      var c = window.GorgiasChat;
      if (c && typeof c.open === 'function') { clearInterval(iv); open(c); }
      else if ((waited += 250) > 8000) { clearInterval(iv); window.location.href = '/pages/contactez-nous#formulaire'; }
    }, 250);
    return true;
  }
  function initHelp(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-bm-chat]:not([data-bm-ready])').forEach(function (b) {
      b.setAttribute('data-bm-ready', '');
      b.addEventListener('click', function () { if (!openChat()) window.location.href = '/pages/contactez-nous#formulaire'; });
    });
    var open = phoneOpen();
    scope.querySelectorAll('[data-bm-phone-status]').forEach(function (el) {
      if (open) { el.textContent = 'Ouvert maintenant · un conseiller vous répond'; el.classList.add('is-open'); }
    });
    scope.querySelectorAll('[data-bm-chat-status]').forEach(function (el) {
      var g = window.GorgiasChat;
      var live = open;
      try { if (g && typeof g.isBusinessHours === 'function') live = !!g.isBusinessHours(); } catch (e) {}
      el.textContent = live ? 'En ligne · réponse en quelques minutes' : 'Laissez un message, on vous répond dès l’ouverture';
      el.classList.toggle('is-open', live);
    });

    var input = scope.querySelector('[data-bm-help-search]');
    if (!input || input.hasAttribute('data-bm-ready')) return;
    input.setAttribute('data-bm-ready', '');
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-bm-help-q]'));
    var groups = Array.prototype.slice.call(scope.querySelectorAll('[data-bm-help-group]'));
    var empty = scope.querySelector('[data-bm-help-empty]');
    var norm = function (s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
    items.forEach(function (d) { d._txt = norm(d.textContent); });
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var words = norm(input.value).split(/\s+/).filter(function (w) { return w.length > 1; });
        var shown = 0;
        items.forEach(function (d) {
          var hit = words.every(function (w) { return d._txt.indexOf(w) > -1; });
          d.hidden = !hit;
          if (hit) shown++;
          if (words.length && hit) d.open = shown <= 2; else if (!words.length) d.open = false;
        });
        groups.forEach(function (g) { g.hidden = !g.querySelector('[data-bm-help-q]:not([hidden])'); });
        if (empty) empty.hidden = shown > 0;
      }, 120);
    });
    // Arrivée sur un thème (#aide-…) : on ouvre sa première question
    if (location.hash.indexOf('#aide-') === 0) {
      var g0 = document.getElementById(location.hash.slice(1));
      var q0 = g0 && g0.querySelector('details');
      if (q0) q0.open = true;
    }
  }

  /* ------------------------------------------------------ Date de livraison estimée (snippets/bm-delivery-estimate)
     Jours ouvrés comptés à partir d'aujourd'hui (heure de Paris), week-ends et jours fériés français exclus. */
  function frHolidays(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    var easter = new Date(y, month - 1, day);
    var add = function (n) { var x = new Date(easter); x.setDate(x.getDate() + n); return x; };
    var list = [new Date(y, 0, 1), add(1), new Date(y, 4, 1), new Date(y, 4, 8), add(39), add(50),
                new Date(y, 6, 14), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25)];
    return list.map(function (x) { return x.toDateString(); });
  }
  function addBusinessDays(start, n) {
    var d = new Date(start), hol = frHolidays(d.getFullYear()).concat(frHolidays(d.getFullYear() + 1)), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6 && hol.indexOf(d.toDateString()) < 0) added++;
    }
    return d;
  }
  function initEta(root) {
    var els = (root || document).querySelectorAll('[data-bm-eta]:not([data-bm-ready])');
    if (!els.length) return;
    var nowParis = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
    var months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    els.forEach(function (el) {
      el.setAttribute('data-bm-ready', '');
      var a = addBusinessDays(nowParis, parseInt(el.getAttribute('data-min'), 10) || 0);
      var b = addBusinessDays(nowParis, parseInt(el.getAttribute('data-max'), 10) || 0);
      var range = a.getMonth() === b.getMonth()
        ? 'entre le ' + a.getDate() + ' et le ' + b.getDate() + ' ' + months[b.getMonth()]
        : 'entre le ' + a.getDate() + ' ' + months[a.getMonth()] + ' et le ' + b.getDate() + ' ' + months[b.getMonth()];
      el.textContent = (el.hasAttribute('data-plan') ? 'Livraison sur rendez-vous, estimée ' : 'Livraison estimée ') + range;
    });
  }

  /* ------------------------------------------------------ Filtres : pastilles, doublons, compteur en direct */
  function initFilters(root) {
    var desk = window.matchMedia('(min-width: 990px)');
    (root || document).querySelectorAll('[data-bm-filters]:not([data-bm-ready])').forEach(function (form) {
      form.setAttribute('data-bm-ready', '');
      var drawer = form.closest('[data-bm-drawer]');
      var btns = form.querySelectorAll('[data-bm-filters-submit]');
      var sectionId = form.getAttribute('data-section');
      var facets = form.querySelectorAll('.bm-facet');
      var timer, ctrl;
      function barMode() { return desk.matches && drawer && !drawer.classList.contains('is-open'); }
      // Barre (ordinateur) : tout fermé ; panneau : filtres utiles ouverts
      function syncOpen() {
        facets.forEach(function (d) { d.open = barMode() ? false : d.hasAttribute('data-open'); });
      }
      syncOpen();
      var bar = form.closest('.bm-toolbar');
      if (bar) {
        // Colle sous l'en-tête du thème quand celui-ci est fixe (il apparaît/disparaît au défilement)
        var hd = document.getElementById('SiteHeader');
        var stuck = function () {
          var off = 0;
          if (hd) {
            var pos = getComputedStyle(hd).position;
            if (pos === 'fixed' || pos === 'sticky') { var r = hd.getBoundingClientRect(); if (r.bottom > 0) off = Math.round(r.bottom); }
          }
          bar.style.top = off + 'px';
          bar.classList.toggle('is-stuck', window.scrollY > 0 && bar.getBoundingClientRect().top <= off + 1);
        };
        window.addEventListener('resize', stuck);
        // L'en-tête devient fixe / change de hauteur après le défilement : on suit ses changements
        if (hd && window.MutationObserver) new MutationObserver(function () { stuck(); setTimeout(stuck, 320); }).observe(hd, { attributes: true, attributeFilter: ['class', 'style'] });
        if (hd && window.ResizeObserver) new ResizeObserver(stuck).observe(hd);
        window.addEventListener('scroll', stuck, { passive: true });
        stuck();
      }
      desk.addEventListener ? desk.addEventListener('change', syncOpen) : desk.addListener(syncOpen);
      if (drawer) new MutationObserver(syncOpen).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      // Un seul menu ouvert à la fois dans la barre, aligné à droite s'il déborde
      facets.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!barMode() || !d.open) return;
          facets.forEach(function (o) { if (o !== d) o.open = false; });
          d.classList.remove('is-right');
          var pop = d.querySelector('.bm-facet__pop');
          if (pop && pop.getBoundingClientRect().right > window.innerWidth - 16) d.classList.add('is-right');
          // Le bouton « Voir les N pièces » doit toujours rester visible : on fait tenir le menu dans l'écran
          if (pop) {
            var fit = function () { pop.style.setProperty('--bm-pop-max', Math.max(260, Math.floor(window.innerHeight - pop.getBoundingClientRect().top - 16)) + 'px'); };
            pop.style.removeProperty('--bm-pop-max');
            var need = pop.getBoundingClientRect().top + pop.scrollHeight + 16 - window.innerHeight;
            fit();
            if (need > 0) { window.scrollBy({ top: need, behavior: 'smooth' }); setTimeout(fit, 400); }
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!barMode() || e.target.closest('.bm-facet')) return;
        facets.forEach(function (o) { o.open = false; });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && barMode()) facets.forEach(function (o) { o.open = false; });
      });
      // Raccourcis mobiles : ouvrent le panneau sur le bon filtre
      var quick = drawer && drawer.parentNode.querySelector('.bm-fquick');
      if (quick) quick.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bm-facet-jump]');
        if (!b) return;
        var opener = document.querySelector('[data-bm-drawer-open="' + drawer.id + '"]');
        if (opener) opener.click();
        var d = form.querySelector('.bm-facet[data-facet="' + b.getAttribute('data-bm-facet-jump') + '"]');
        if (d) setTimeout(function () { d.open = true; d.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 60);
      });
      function countText(opt, c) {
        return opt && opt.closest('.bm-facet__opts--grade') ? c + (c > 1 ? ' pièces' : ' pièce') : String(c);
      }
      // Doublons fusionnés : l'option visible affiche le total des valeurs équivalentes
      form.querySelectorAll('.bm-facet__dup[data-count]').forEach(function (dup) {
        var norm = dup.getAttribute('data-norm');
        var main = Array.prototype.find.call(form.querySelectorAll('.bm-fopt input[data-norm]'), function (i) { return i.getAttribute('data-norm') === norm; });
        var small = main && main.closest('.bm-fopt').querySelector('small');
        if (small) small.textContent = countText(main.closest('.bm-fopt'), (parseInt(small.textContent, 10) || 0) + (parseInt(dup.getAttribute('data-count'), 10) || 0));
      });
      // Listes (marques, types, matières…) : les options cochées d'abord, puis par stock décroissant,
      // pour que « Voir les N » ne cache que les petites valeurs
      form.querySelectorAll('.bm-facet__opts--list').forEach(function (box) {
        var more = box.querySelector('[data-bm-facet-more]');
        var opts = Array.prototype.slice.call(box.querySelectorAll(':scope > .bm-fopt'));
        var n = function (o) { return parseInt((o.querySelector('small') || {}).textContent, 10) || 0; };
        opts.sort(function (a, b) {
          var aa = a.classList.contains('is-on'), bb = b.classList.contains('is-on');
          return aa !== bb ? (aa ? -1 : 1) : n(b) - n(a);
        });
        opts.forEach(function (o, i) {
          box.insertBefore(o, more);
          if (more) o.classList.toggle('is-more', i >= 12 && !o.classList.contains('is-on'));
        });
      });
      form.querySelectorAll('[data-bm-facet-more]').forEach(function (b) {
        b.setAttribute('data-label', b.textContent);
        b.addEventListener('click', function () {
          var open = b.closest('.bm-facet__opts').classList.toggle('is-expanded');
          b.textContent = open ? 'Voir moins' : b.getAttribute('data-label');
        });
      });
      // Recherche dans les listes longues (marques, matières…)
      form.querySelectorAll('[data-bm-facet-search]').forEach(function (inp) {
        var box = inp.closest('.bm-facet__pop').querySelector('.bm-facet__opts');
        inp.addEventListener('input', function () {
          var q = inp.value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
          box.classList.toggle('is-searching', q !== '');
          box.querySelectorAll('.bm-fopt').forEach(function (o) {
            var l = (o.getAttribute('data-label') || '').normalize('NFD').replace(/[̀-ͯ]/g, '');
            o.hidden = q !== '' && l.indexOf(q) === -1;
          });
        });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      });
      // Prix : curseur double relié aux champs, tranches rapides
      form.querySelectorAll('[data-bm-price]').forEach(function (p) {
        var max = parseInt(p.getAttribute('data-max'), 10) || 1;
        var lo = p.querySelector('[data-bm-price-lo]'), hi = p.querySelector('[data-bm-price-hi]');
        var mn = p.querySelector('[data-bm-price-min]'), mx = p.querySelector('[data-bm-price-max]');
        var track = p.querySelector('.bm-price__range');
        function paint() {
          track.style.setProperty('--lo', (lo.value / max * 100) + '%');
          track.style.setProperty('--hi', (hi.value / max * 100) + '%');
          p.querySelectorAll('.bm-price__quick button').forEach(function (b) {
            b.classList.toggle('is-on', (b.getAttribute('data-lo') || '') === mn.value && (b.getAttribute('data-hi') || '') === mx.value && (mn.value || mx.value));
          });
        }
        function fromRange(e) {
          if (+lo.value > +hi.value) { if (e.target === lo) lo.value = hi.value; else hi.value = lo.value; }
          mn.value = +lo.value > 0 ? lo.value : '';
          mx.value = +hi.value < max ? hi.value : '';
          paint(); refreshCount();
        }
        lo.addEventListener('input', fromRange); hi.addEventListener('input', fromRange);
        [mn, mx].forEach(function (i) {
          i.addEventListener('input', function () { lo.value = mn.value || 0; hi.value = mx.value || max; paint(); });
        });
        p.querySelectorAll('.bm-price__quick button').forEach(function (b) {
          b.addEventListener('click', function () {
            var on = b.classList.contains('is-on');
            mn.value = on ? '' : (b.getAttribute('data-lo') || '');
            mx.value = on ? '' : (b.getAttribute('data-hi') || '');
            lo.value = mn.value || 0; hi.value = mx.value || max;
            paint(); refreshCount();
          });
        });
        paint();
      });
      // « Effacer » dans un menu : vide ce filtre et applique
      form.querySelectorAll('[data-bm-facet-clear]').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.closest('.bm-facet');
          d.querySelectorAll('input[type="checkbox"]').forEach(function (i) {
            i.checked = false;
            var norm = i.getAttribute('data-norm');
            if (norm) form.querySelectorAll('.bm-facet__dup').forEach(function (o) { if (o.getAttribute('data-norm') === norm) o.checked = false; });
          });
          d.querySelectorAll('input[type="number"]').forEach(function (i) { i.value = ''; });
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      });
      function label(n) {
        return n === 0 ? 'Rien ici, on élargit un peu ?' : 'Voir ' + (n === 1 ? 'la pièce' : 'les ' + n + ' pièces');
      }
      // Compte par option d'après la page filtrée (doublons fusionnés compris). Les filtres où
      // une option est déjà cochée ne sont pas grisés (choix multiples dans un même filtre).
      function countsFrom(doc) {
        var m = {};
        doc.querySelectorAll('#BmFilters .bm-fopt input[data-norm]').forEach(function (i) {
          var sm = i.closest('.bm-fopt').querySelector('small');
          m[i.getAttribute('data-norm')] = (m[i.getAttribute('data-norm')] || 0) + (parseInt(sm && sm.textContent, 10) || 0);
        });
        doc.querySelectorAll('#BmFilters .bm-facet__dup[data-norm]').forEach(function (i) {
          var k = i.getAttribute('data-norm');
          if (k in m) m[k] += parseInt(i.getAttribute('data-count'), 10) || 0;
        });
        return m;
      }
      function syncCounts(doc) {
        var m = countsFrom(doc);
        facets.forEach(function (d) {
          if (d.querySelector('.bm-fopt input:checked')) return;
          d.querySelectorAll('.bm-fopt input[data-norm]').forEach(function (i) {
            var c = m[i.getAttribute('data-norm')] || 0;
            var opt = i.closest('.bm-fopt');
            var sm = opt.querySelector('small');
            if (sm) sm.textContent = countText(opt, c);
            opt.classList.toggle('is-zero', c === 0);
          });
        });
      }
      // Tranches de prix : nombre de pièces par tranche, calculé à l'ouverture du filtre Prix
      var priceCache = {};
      function priceCounts(p) {
        if (!sectionId) return;
        var base = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (v !== '' && k.indexOf('filter.v.price') !== 0) base.append(k, v); });
        base.set('section_id', sectionId);
        p.querySelectorAll('.bm-price__quick button').forEach(function (b) {
          var q = new URLSearchParams(base);
          if (b.getAttribute('data-lo')) q.set('filter.v.price.gte', b.getAttribute('data-lo'));
          if (b.getAttribute('data-hi')) q.set('filter.v.price.lte', b.getAttribute('data-hi'));
          var key = q.toString();
          var out = b.querySelector('[data-bm-tranche-n]');
          function show(n) { if (out) out.textContent = isNaN(n) ? '' : n; b.classList.toggle('is-zero', n === 0); }
          if (key in priceCache) { show(priceCache[key]); return; }
          priceCache[key] = NaN;
          fetch(form.getAttribute('action') + '?' + key, { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var el = new DOMParser().parseFromString(html, 'text/html').querySelector('.bm-coll__count b, [data-bm-results-count]');
              var n = el ? parseInt(el.textContent.replace(/\D/g, ''), 10) : NaN;
              priceCache[key] = n; show(n);
            })
            .catch(function () {});
        });
      }
      form.querySelectorAll('.bm-facet--price').forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) priceCounts(d.querySelector('[data-bm-price]')); });
      });
      function refreshCount() {
        if (!btns.length || !sectionId) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var params = new URLSearchParams();
          new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
          params.set('section_id', sectionId);
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          btns.forEach(function (b) { b.classList.add('is-loading'); });
          fetch(form.getAttribute('action') + '?' + params.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var el = doc.querySelector('.bm-coll__count b, [data-bm-results-count]');
              var n = el ? parseInt(el.textContent.replace(/\D/g, ''), 10) : NaN;
              btns.forEach(function (b) {
                b.classList.remove('is-loading');
                b.disabled = n === 0;
                b.classList.toggle('is-empty', n === 0);
                b.textContent = isNaN(n) ? 'Voir les résultats' : label(n);
              });
              syncCounts(doc);
              priceCache = {};
              form.querySelectorAll('.bm-facet--price[open] [data-bm-price]').forEach(priceCounts);
            })
            .catch(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
        }, 250);
      }
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches('input[type="checkbox"][data-norm]')) {
          var norm = t.getAttribute('data-norm');
          form.querySelectorAll('input[type="checkbox"][data-norm]').forEach(function (o) {
            if (o !== t && o.getAttribute('data-norm') === norm) o.checked = t.checked;
          });
          var opt = t.closest('.bm-fopt');
          if (opt) opt.classList.toggle('is-on', t.checked);
        }
        if (t && (t.type === 'range' || t.type === 'search')) return;
        refreshCount();
      });
      form.addEventListener('input', function (e) { if (e.target && e.target.type === 'number') refreshCount(); });
      // Champs vides et curseurs : jamais dans l'URL
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
        form.querySelectorAll('input[type="range"], input[type="search"]').forEach(function (i) { i.disabled = true; });
      });
    });
  }

  /* ------------------------------------------------------ Description : même typo que « Caractéristiques » */
  // Les descriptions mêlent intertitres à emoji, puces emoji et lignes « Libellé : valeur » en gras.
  // On les remet en forme à l'affichage (le texte de la fiche n'est pas modifié) :
  // intertitres sobres, vraie liste à puces, lignes libellé/valeur en tableau comme les caractéristiques.
  var EMO = /^[\s ]*(?:[☀-➿⬀-⯿]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF])[️‍⃣\s ]*(?:(?:[☀-➿]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF])[️‍\s ]*)*/;
  function stripLeadEmoji(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      n.nodeValue = n.nodeValue.replace(EMO, '');
      return;
    }
  }
  function tidyDescription(root) {
    (root || document).querySelectorAll('[data-bm-desc]:not([data-bm-tidy])').forEach(function (rte) {
      rte.setAttribute('data-bm-tidy', '');
      try {
        // 1. Un paragraphe = une ligne (les <br> deviennent des paragraphes)
        rte.querySelectorAll('p').forEach(function (p) {
          if (!/<br\s*\/?>/i.test(p.innerHTML)) return;
          var parts = p.innerHTML.split(/<br\s*\/?>/i).map(function (h) { return h.trim(); }).filter(function (h) { return h.replace(/<[^>]*>|&nbsp;/g, '').trim(); });
          if (parts.length < 2) return;
          var frag = document.createDocumentFragment();
          parts.forEach(function (h) { var q = document.createElement('p'); q.innerHTML = h; frag.appendChild(q); });
          p.parentNode.replaceChild(frag, p);
        });
        // Listes dont chaque puce contient un paragraphe : on aplatit
        rte.querySelectorAll('li > p:only-child').forEach(function (p) { p.parentNode.innerHTML = p.innerHTML; });
        // 2. Classement ligne à ligne
        var KV = /^([^:]{2,42}?)\s*:\s*(\S[\s\S]*)$/;
        function kind(el) {
          var t = (el.textContent || '').replace(/ /g, ' ').trim();
          if (!t) return 'empty';
          var emo = EMO.test(t) && t.replace(EMO, '').trim() !== t;
          var rest = t.replace(EMO, '').trim();
          var bold = el.querySelector('strong, b');
          var allBold = bold && bold.textContent.trim().length >= rest.replace(/:$/, '').trim().length - 1;
          if (/^H[2-6]$/.test(el.tagName) || (rest.length <= 48 && allBold && !KV.test(rest.replace(/:$/, '')))) return 'head';
          var m = rest.match(KV);
          if (emo && m && rest.length <= 120 && /\d/.test(m[2]) && bold && bold.textContent.indexOf(m[1].trim().slice(0, 6)) > -1) return 'kv';
          if (emo) return 'item';
          if (m && rest.length <= 160 && !/[.!?]\s/.test(m[1]) && (bold || /^[A-ZÀ-Ý]/.test(m[1]))) return 'kv';
          return 'text';
        }
        var nodes = Array.prototype.slice.call(rte.children), list = null, dl = null;
        nodes.forEach(function (el) {
          if (el.tagName === 'UL' || el.tagName === 'OL') {
            var lis = Array.prototype.slice.call(el.children);
            if (lis.length && lis.every(function (li) { return kind(li) === 'kv'; })) {
              var d = document.createElement('dl'); d.className = 'bm-spectable bm-rte__dl';
              lis.forEach(function (li) { var m = li.textContent.replace(/ /g, ' ').trim().match(KV); var r = document.createElement('div'); r.innerHTML = '<dt></dt><dd></dd>'; r.firstChild.textContent = m[1]; r.lastChild.textContent = m[2]; d.appendChild(r); });
              el.parentNode.replaceChild(d, el);
            } else {
              el.classList.add('bm-rte__list');
              lis.forEach(stripLeadEmoji);
            }
            list = dl = null; return;
          }
          var k = kind(el);
          if (k === 'empty') { el.parentNode.removeChild(el); return; }
          if (k === 'head') {
            var h = document.createElement('p'); h.className = 'bm-rte__h';
            h.textContent = el.textContent.replace(/ /g, ' ').trim().replace(EMO, '').replace(/\s*:$/, '').trim();
            el.parentNode.replaceChild(h, el); list = dl = null; return;
          }
          if (k === 'item') {
            if (!list) { list = document.createElement('ul'); list.className = 'bm-rte__list'; el.parentNode.insertBefore(list, el); }
            var li = document.createElement('li'); li.innerHTML = el.innerHTML; stripLeadEmoji(li); list.appendChild(li);
            el.parentNode.removeChild(el); dl = null; return;
          }
          if (k === 'kv') {
            var m = el.textContent.replace(/ /g, ' ').trim().replace(EMO, '').match(KV);
            if (!dl) { dl = document.createElement('dl'); dl.className = 'bm-spectable bm-rte__dl'; el.parentNode.insertBefore(dl, el); }
            var r = document.createElement('div'); r.innerHTML = '<dt></dt><dd></dd>'; r.firstChild.textContent = m[1]; r.lastChild.textContent = m[2]; dl.appendChild(r);
            el.parentNode.removeChild(el); list = null; return;
          }
          list = dl = null;
        });
      } catch (e) { /* en cas de format imprévu, la description reste telle quelle */ }
    });
  }

  /* ------------------------------------------------------ Hero : plusieurs bannières */
  function initHero(root) {
    (root || document).querySelectorAll('[data-bm-hero]:not([data-bm-ready])').forEach(function (hero) {
      hero.setAttribute('data-bm-ready', '');
      var track = hero.querySelector('[data-bm-hero-track]');
      var slides = track.children, dots = hero.querySelectorAll('[data-bm-hero-dot]');
      var n = slides.length, cur = 0, timer = null, paused = false;
      var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(i, smooth) {
        cur = (i + n) % n;
        track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
      }
      function mark() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i < 0 || i >= n) return;
        cur = i;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      var raf = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-bm-hero-dot')); restart(); }); });
      var prev = hero.querySelector('[data-bm-hero-prev]'), next = hero.querySelector('[data-bm-hero-next]');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(cur + 1); restart(); });
      function restart() {
        clearInterval(timer); timer = null;
        if (!delay || reduce) return;
        timer = setInterval(function () { if (!paused && !document.hidden) go(cur + 1); }, delay * 1000);
      }
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { hero.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { hero.addEventListener(ev, function () { paused = false; }); });
      hero.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
      // Éditeur de thème : afficher la bannière sélectionnée
      hero.addEventListener('shopify:block:select', function (e) {
        var k = Array.prototype.indexOf.call(slides, e.target.closest('.bm-hero__slide'));
        if (k >= 0) { paused = true; go(k, false); }
      });
      hero.addEventListener('shopify:block:deselect', function () { paused = false; });
      restart();
    });
  }

  /* ------------------------------------------------------ Démarrage */
  function init(root) {
    frenchSpaces(root);
    initHero(root);
    tidyDescription(root);
    initHelp(root);
    initEta(root);
    initFilters(root);
    initCountdowns(root);
    initCollection();
    initReco(root);
    initCart(root);
    renderRecent(root);
    (root || document).querySelectorAll('[data-bm-pdp]:not([data-bm-ready])').forEach(function (p) {
      p.setAttribute('data-bm-ready', '');
      initProduct(p);
    });
  }
  scheduleTrustpilot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
